module.exports = __webpack_public_path__ + "img/kpn_logo_white_founding_partner.dc7146d9.svg";